<form #f="ngForm" [formGroup]="searchForm" (ngSubmit)="onSubmit(f)" [ngClass]="{'third_element_to_target': true, 'mobile': mobile}">
  <mat-form-field appearance="outline" class="form-field-full-width">
    <div class="search-bar-left">
      <input #headerSearchBar type="text" [placeholder]="'searchFor.TITLE' | translate" [attr.aria-label]="label" matInput
        formControlName="searchTerm" [matAutocomplete]="auto" maxlength="60" [attr.tabindex]="initialTabindex" attr.aria-label="{{'searchFor.ARIA_LABEL' | translate}}">
    </div>
    <div class="search-bar-button-right">
      <button #btnSearch class="button button-focusable" (click)="onSubmit(f)" [attr.tabindex]="initialTabindex">
        <mat-icon matSuffix id="iconSearch">search</mat-icon>
      </button>
      <button class="button button-focusable"  (click)="clearSearchField()" [ngClass]="{'hidden': !searchTermIsLengthy}" [attr.tabindex]="initialTabindex">
        <mat-icon matSuffix>close</mat-icon>
      </button>
    </div>
    <mat-autocomplete aria-hidden="true" #auto="matAutocomplete" (optionSelected)='!isSearch? onSubmit(f): redirectPage()' (opened)="onOpenOptions()"
      (closed)="onCloseOptions()" underlineStyle={false}>
      <div *ngIf="flgShow">
        <div *ngIf="!isSearch" class="last-search-text">
          <span class="title">{{ 'recentSearchText.TITLE' | translate }}</span>
        </div>
        <div *ngIf="isSearch" class="last-search-text">
          <span class="title">{{ 'screenText.TITLE' | translate }}</span>
        </div>
      </div>
      <div class="search-box">
        <mat-option id="searchBarOptionList" *ngFor="let option of subMenus" [value]="option.translationKey + '.TRANSLATION' | translate" class="height-auto">
          <app-search-result-item [isSearchBar]="false" *ngIf="isSearch" [title]="option.translationKey" [description]="option.path" [id]="option.id" [typeMenu]="option.tipoMenu"></app-search-result-item>
          <div class="search-page-text height30" *ngIf="!isSearch">
            <mat-icon class="icon-color" matSuffix>fiber_manual_record</mat-icon>
            <span class="search-page-text title">{{option.translationKey + ".TRANSLATION" | translate }}</span>
          </div>
        </mat-option>
        <mat-option *ngIf="!flgShow" disabled>
          <span class="search-page-text"> {{ 'noResults.TITLE' | translate }}</span>
        </mat-option>
      </div>
    </mat-autocomplete>
  </mat-form-field>
</form>
